import { useTranslation } from 'react-i18next';

export default function AssociationTable() {
  const { t } = useTranslation();
  const tableKeys = [
    { label: 'association.table.label1', value: 'association.table.value1', isPrivate: false },
    { label: 'association.table.label7', value: 'association.table.value7', isPrivate: false },
    { label: 'association.table.label8', value: 'association.table.value8', isPrivate: false },
    { label: 'association.table.label2', value: 'association.table.value2', isPrivate: false },
    { label: 'association.table.label3', value: 'association.table.value3', isPrivate: false },
    { label: 'association.table.label4', value: 'association.table.value4', isPrivate: false },
    { label: 'association.table.label5', value: 'association.table.value5', isPrivate: false },
    { label: 'association.table.label6', value: 'association.table.value6', isPrivate: false },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            ORGANIZATION
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('association.table.title')}
          </h2>
          {String(t('association.table.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        {/* Desktop table */}
        <div className="hidden md:block border border-background-200/60">
          {tableKeys.map((item, idx) => (
            <div
              key={idx}
              className={`flex ${
                idx % 2 === 0 ? 'bg-background-100/40' : 'bg-background-50'
              }`}
            >
              <div className="w-[180px] flex-shrink-0 bg-primary-900 py-4 px-6">
                <span className="text-[15px] text-accent-400 tracking-[0.06em] font-medium">
                  {t(item.label)}
                </span>
              </div>
              <div className="flex-1 py-4 px-6">
                <span className={`text-[15px] tracking-[0.04em] leading-relaxed ${item.isPrivate ? 'text-foreground-400' : 'text-foreground-700'}`}>
                  {t(item.value)}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile stacked */}
        <div className="md:hidden space-y-1">
          {tableKeys.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/60 p-4"
            >
              <span className="block text-[13px] text-accent-500 tracking-[0.08em] font-medium mb-1">
                {t(item.label)}
              </span>
              <span className={`block text-[15px] tracking-[0.04em] leading-relaxed ${item.isPrivate ? 'text-foreground-400' : 'text-foreground-700'}`}>
                {t(item.value)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
